import { administrationRequests } from "api/administrationApi";
import React from "react";
import { AutocompleteInput, ReferenceInput, required } from "react-admin";

const RoomInput = ({
  style,
  label = "Зала",
  source = "roomId",
  isRequired = false,
  render = rec => `${rec.roomName} - ${rec.buildingName}`,
}) => {
  return (
    <ReferenceInput
      source={source}
      label={label}
      reference={administrationRequests.getRoomsSelect()}
    >
      <AutocompleteInput
        label="Зала"
        optionValue="id"
        optionText={rec => `${rec.roomName} - ${rec.buildingName}`}
        filterToQuery={q => (q?.length > 2 ? { name: q } : {})}
        fullWidth
        style={style}
        validate={isRequired ? required() : undefined}
      />
    </ReferenceInput>
  );
};

export default RoomInput;
